import { render, staticRenderFns } from "./OfflineQueue.vue?vue&type=template&id=6daa8a4b"
import script from "./OfflineQueue.vue?vue&type=script&lang=js"
export * from "./OfflineQueue.vue?vue&type=script&lang=js"
import style0 from "./OfflineQueue.vue?vue&type=style&index=0&id=6daa8a4b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports